/* DSL Review stars input — convert radio-rating naar star-buttons met hover-preview */
(function(){
  document.querySelectorAll(".dsl-review-submit__rating").forEach(function(fs){
    var radios = fs.querySelectorAll("input[type=radio]");
    var stars = document.createElement("div");
    stars.className = "dsl-stars-input";
    radios.forEach(function(r, i){
      var s = document.createElement("button");
      s.type = "button";
      s.className = "dsl-stars-input__star";
      s.textContent = "★";
      s.setAttribute("aria-label", (i+1) + " sterren");
      s.dataset.value = r.value;
      s.addEventListener("click", function(){
        r.checked = true;
        stars.querySelectorAll(".dsl-stars-input__star").forEach(function(b, j){
          b.classList.toggle("is-on", j <= i);
        });
      });
      s.addEventListener("mouseenter", function(){
        stars.querySelectorAll(".dsl-stars-input__star").forEach(function(b, j){
          b.classList.toggle("is-hover", j <= i);
        });
      });
      stars.appendChild(s);
    });
    stars.addEventListener("mouseleave", function(){
      stars.querySelectorAll(".dsl-stars-input__star").forEach(function(b){ b.classList.remove("is-hover"); });
    });
    fs.appendChild(stars);
    radios.forEach(function(r){ r.style.position = "absolute"; r.style.left = "-9999px"; });
  });
})();